import React, { useEffect, useRef, useState } from "react";
import { Box, Stack, Typography } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "components/common/CustomTypography";
import TextareaOnboarding from "components/onboarding/TextareaOnboarding";
import { useNavigate } from "react-router-dom";
import { useOnboardingPromotionData } from "../../../../hooks/useOnboardingPromotionData";
import { BottomNextButtonTmp } from "../../../../components/common/BottomNextButtonTmp";

export default function Demographic_3_Promotion() {
  const navigate = useNavigate();
  /* ➊ HTMLTextAreaElement 참조용 useRef 생성 */
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const { text: age, updateText: updateAge } =
    useOnboardingPromotionData("demographic_3");

  const [isFocused, setIsFocused] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const isButtonDisabled =
    age === undefined || age === "" || Number(age) <= 7 || Number(age) >= 100;

  function handleSubmit() {
    if (age && age.length > 0 && Number(age) > 7) {
      navigate("/promotion-onboarding/demographic/4");
    }
  }

  /* ➋ 페이지 로드 후 자동으로 텍스트에어리어에 포커스 */
  useEffect(() => {
    if (textAreaRef.current) {
      textAreaRef.current.focus();
    }
  }, []);

  return (
    <Stack spacing={5} sx={{ height: "100%" }}>
      <Stack spacing={2}>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {
            "인생의 어느 시기를 지나고 있느냐에 따라 마음속 중요한 주제들이 변화하기도 한답니다."
          }
        </CustomTypography>
        <CustomTypography
          variant="Subtitle"
          fontWeight={500}
          sx={{ color: theme.vars.palette.Content.Strong }}
        >
          {"나이는 어떻게 되나요?"}
        </CustomTypography>
      </Stack>

      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={1}
        sx={{ width: "100%" }}
      >
        <Typography
          variant="Body"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          만
        </Typography>
        <Box
          sx={{
            width: "100px",
            height: "54px",
            backgroundColor: theme.vars.palette.Surface.Forward,
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            boxShadow: isFocused
              ? `inset 0 0 0 1.333px ${theme.vars.palette.Content.Highlight}`
              : `inset 0 0 0 0`,
          }}
        >
          <TextareaOnboarding
            initialValue={age}
            handleChange={(newValue: string) => updateAge(newValue)}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            emojiDisabled={true}
            readOnly={false}
            textAlign={"center"}
            numbersOnly={true}
            maxLength={2}
            /* ➌ 여기서 자식(TextareaOnboarding)에 ref를 넘김 */
            // inputRef={textAreaRef}
          />
        </Box>
        <Typography
          variant="Body"
          fontWeight={500}
          sx={{
            color: theme.vars.palette.Content.Strong,
          }}
        >
          세
        </Typography>
      </Stack>

      <BottomNextButtonTmp
        loading={loading}
        disabled={isButtonDisabled}
        onClick={handleSubmit}
        text={"다음"}
        highlightBackground={false}
      />
    </Stack>
  );
}
